const INITIAL_STATE = {
  loading: false,
  list: [],
  total: 0,
};

/**
 * @param {Object} state - Default application state
 * @param {Object} action - Action from action creator
 * @returns {Object} New state
 */
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'CONTACTS_FETCHED':
      return { ...state, list: action.payload, loading: false };
    case 'CONTACTS_LOAD':
      return { ...state, loading: action.payload };
    default:
      return state;
  }
};
